module.exports = __webpack_public_path__ + "static/media/evnt.52de7722.png";